<!-- 重设查询条件页面 -->
<template>
  <div class="page-container">
    <!-- 顶部导航栏 -->
    <Header></Header>
    
    <div class="main-layout">
      <!-- 左侧菜单 -->
      <div class="sidebar">
        <MenuList></MenuList>
      </div>
      
      <!-- 主内容区 -->
      <div class="content">
        <!-- 页面头部 -->
        <div class="page-header">
          <div class="header-title">
            <el-button type="text" @click="backToHome" class="back-btn">
              <i class="el-icon-arrow-left"></i>返回
            </el-button>
            <h1>重设《{{form_name}}》查询条件</h1>
          </div>
          
          <div class="header-tips">
            <div class="tip-item">
              <i class="el-icon-info tip-icon"></i>
              <span>请从左框中查询条件列(如姓名,身份证等,最多两个)选到右侧框中</span>
            </div>
            <div class="tip-item warning">
              <i class="el-icon-warning tip-icon"></i>
              <span>特别注意:必须选择每个人都有数据的列,否则部分人将无法查询</span>
            </div>
          </div>
        </div>
        
  <!-- 转移组件区域 -->
  <div class="transfer-section">
    <div class="transfer-wrapper">
      <el-skeleton :rows="5" animated v-if="transferList.length === 0" class="loading-skeleton">
        <template slot="template">
          <el-skeleton-item variant="rect" style="height: 320px; margin-bottom: 16px;" />
          <div style="display: flex; gap: 12px;">
            <el-skeleton-item variant="rect" style="width: 120px; height: 32px;" />
            <el-skeleton-item variant="rect" style="width: 120px; height: 32px;" />
          </div>
        </template>
      </el-skeleton>
      
      <el-transfer 
        v-model="selectedSearchCondition" 
        :data="transferList"
        :titles="['可以选用的列', '用于查询的列']"
        :button-texts="['移除', '添加']"
        :format="{
          noChecked: '${total}',
          hasChecked: '${checked}/${total}'
        }"
        target-order="push"
        filterable
        filter-placeholder="搜索列名"
        class="custom-transfer"
        v-if="transferList.length > 0">
      </el-transfer>
            
            <div class="transfer-tips">
              <div class="tip-box">
                <i class="el-icon-success"></i>
                <span>已选择 {{selectedSearchCondition.length}} 个查询列</span>
              </div>
              <div class="tip-box" v-if="selectedSearchCondition.length === 0">
                <i class="el-icon-warning"></i>
                <span>请至少选择一个查询条件</span>
              </div>
              <div class="tip-box warning" v-if="selectedSearchCondition.length > 2">
                <i class="el-icon-error"></i>
                <span>查询条件不能超过2个</span>
              </div>
            </div>
          </div>
        </div>
        
        <!-- 底部操作栏 -->
        <div class="action-section">
          <div class="action-tips">
            <p><strong>使用提示：</strong></p>
            <p>1. 查询条件用于数据检索，建议选择唯一性高的列（如学号、工号）</p>
            <p>2. 最多可选择2个查询条件，太多会影响填写体验</p>
            <p>3. 已选条件会显示在右侧面板中</p>
          </div>
          
          <div class="action-buttons">
            <el-button @click="backToHome" plain size="medium">取消</el-button>
            <el-button 
              type="primary" 
              size="medium" 
              @click="saveCondition"
              :disabled="selectedSearchCondition.length === 0 || selectedSearchCondition.length > 2"
              :loading="saving"
              class="save-btn">
              <i class="el-icon-check"></i>完成设置，立即保存
            </el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import MenuList from './menu.vue'
  import Header from './head.vue'

  export default {
    components: {
      MenuList,
      Header
    },
    data() {
      return {
        username: '',
        form_id: '',
        form_name: '',
        conditions: [],
        fields: [],
        transferList: [],
        selectedSearchCondition: [],
        message: '',
        page_from: '',
        saving: false
      }
    },
    created() {
      this.username = this.$session.get('USERNAME')
      this.form_id = this.$route.params.form_id
      this.form_name = this.$route.params.form_name
      this.page_from = this.$route.params.page_from
      this.loadConditions()
    },
    methods: {
      loadConditions() {
        let that = this

        var requestUrl = '/checking/web/_load_condition_value_list.jsp'
        this.axios.get(requestUrl, {
            params: {
              query_id: that.form_id,
            }
          }).then(function(response) {
            that.fields = response.data.field_list

            that.transferList = []
            for (var i = 0; i < that.fields.length; i++) {
              let item = {
                key: that.fields[i].field_name,
                label: that.fields[i].field_name,
                disabled: false
              }
              that.transferList.push(item)
            }

            var tmpList = response.data.conditions
            that.selectedSearchCondition = []
            for (var i = 0; i < tmpList.length; i++) {
              var str = tmpList[i].condition_name
              that.selectedSearchCondition.push(str)
            }
          })
          .catch(function(error) {
            console.log(error)
            this.$message.error('加载查询条件失败')
          })
      },
      saveCondition() {
        if (this.selectedSearchCondition.length === 0) {
          this.$message.error('至少选一个查询条件,如姓名、工号、学号等(最多2个)')
          return
        }

        if (this.selectedSearchCondition.length > 2) {
          this.$message.error('不要超过2个查询条件(最多2个),否则录入会很困难,请重新选择！')
          return
        }

        let that = this
        var jsonStr = JSON.stringify(this.selectedSearchCondition)
        var requestUrl = '/checking/web/_reset_condition_save.jsp'
        let data = {
          conditions: jsonStr,
          form_id: that.form_id
        }

        var qs = require('qs')
        this.saving = true

        const load = this.$loading({
          lock: true,
          text: '正在保存查询条件...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })

        this.axios.post(
            requestUrl,
            qs.stringify(data), {
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
              }
            }
          ).then(function(response) {
            load.close()
            that.saving = false
            
            that.$message({
              duration: 3000,
              message: '查询条件保存成功！',
              type: 'success'
            })

            // 延迟跳转，让用户看到成功提示
            setTimeout(() => {
              if (that.page_from === '') {
                that.$router.push({
                  path: '/query_list',
                  params: {
                    username: that.username
                  }
                })
              } else {
                that.$router.push({
                  name: 'browse_all_data',
                  params: {
                    form_id: that.form_id,
                    form_name: that.form_name
                  }
                })
              }
            }, 1500)
          })
          .catch(function(error) {
            console.log(error)
            load.close()
            that.saving = false
            that.$message.error('保存失败，请重试')
          })
      },
      backToHome() {
        if (this.page_from === '') {
          this.$router.go(-1)
        } else {
          this.$router.push({
            name: 'browse_all_data',
            params: {
              form_id: this.form_id,
              form_name: this.form_name
            }
          })
        }
      }
    }
  }
</script>

<style scoped>
.page-container {
  min-height: 100vh;
  background: #f5f7fa;
  display: flex;
  flex-direction: column;
}

.main-layout {
  flex: 1;
  display: flex;
  min-height: calc(100vh - 60px);
}

.sidebar {
  width: 200px;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
}

.content {
  flex: 1;
  padding: 20px;
  overflow: auto;
}

/* 页面头部 */
.page-header {
  margin-bottom: 24px;
}

.header-title {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.header-title h1 {
  font-size: 22px;
  font-weight: 600;
  color: #333;
  margin: 0;
  flex: 1;
}

.back-btn {
  margin-right: 12px;
  color: #666;
  font-size: 14px;
}

.back-btn:hover {
  color: #1485FB;
}

.header-tips {
  background: #fff;
  border-radius: 10px;
  padding: 20px;
  box-shadow: 0 4px 16px rgba(0,0,0,0.08);
  border: 1px solid #e8f1ff;
  position: relative;
  overflow: hidden;
}

.header-tips::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 4px;
  height: 100%;
  background: linear-gradient(135deg, #1485FB 0%, #0066CC 100%);
}

.tip-item {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin-bottom: 12px;
  font-size: 14px;
  color: #5a6c7d;
  padding: 8px;
  border-radius: 6px;
  transition: all 0.3s ease;
}

.tip-item:hover {
  background: rgba(20, 133, 251, 0.05);
}

.tip-item.warning {
  color: #e6a23c;
  background: rgba(230, 162, 60, 0.05);
}

.tip-item.warning:hover {
  background: rgba(230, 162, 60, 0.1);
}

.tip-item:last-child {
  margin-bottom: 0;
}

.tip-icon {
  font-size: 16px;
  flex-shrink: 0;
  margin-top: 1px;
}

/* 转移组件区域 */
.transfer-section {
  background: #fff;
  border-radius: 8px;
  padding: 24px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.06);
  margin-bottom: 24px;
}

.transfer-wrapper {
  max-width: 800px;
  margin: 0 auto;
}

.transfer-tips {
  margin-top: 20px;
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.tip-box {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 12px;
  background: #f0f9ff;
  border-radius: 6px;
  font-size: 13px;
  color: #1485FB;
}

.tip-box.warning {
  background: #fdf6ec;
  color: #e6a23c;
}

.tip-box i {
  font-size: 14px;
}

/* 自定义转移组件样式 */
::v-deep .custom-transfer .el-transfer-panel {
  border: 1px solid #e4e7ed;
  border-radius: 8px;
  overflow: hidden;
  transition: all 0.3s ease;
}

::v-deep .custom-transfer .el-transfer-panel:hover {
  border-color: #1485FB;
  box-shadow: 0 2px 8px rgba(20, 133, 251, 0.15);
}

::v-deep .custom-transfer .el-transfer-panel__header {
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  border-bottom: 1px solid #e4e7ed;
  padding: 12px 16px;
  font-weight: 600;
  color: #333;
  font-size: 14px;
}

::v-deep .custom-transfer .el-transfer-panel__body {
  height: 320px;
}

::v-deep .custom-transfer .el-transfer-panel__list {
  height: calc(100% - 40px);
}

::v-deep .custom-transfer .el-transfer__buttons {
  padding: 0 30px;
}

::v-deep .custom-transfer .el-transfer__button {
  border-radius: 6px;
  border-color: #1485FB;
  color: #1485FB;
  transition: all 0.3s ease;
}

::v-deep .custom-transfer .el-transfer__button:hover {
  background: #1485FB;
  color: white;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(20, 133, 251, 0.3);
}

::v-deep .custom-transfer .el-transfer__button:first-child {
  margin-bottom: 12px;
}

::v-deep .custom-transfer .el-transfer__button.is-disabled {
  border-color: #dcdfe6;
  color: #c0c4cc;
  cursor: not-allowed;
}

::v-deep .custom-transfer .el-transfer__button.is-disabled:hover {
  background: #fff;
  color: #c0c4cc;
  transform: none;
  box-shadow: none;
}

::v-deep .custom-transfer .el-checkbox__label {
  font-size: 13px;
  color: #5a6c7d;
}

::v-deep .custom-transfer .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #1485FB;
  font-weight: 500;
}

/* 底部操作栏 */
.action-section {
  background: #fff;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.06);
}

.action-tips {
  background: #f8f9fa;
  border-radius: 6px;
  padding: 16px;
  margin-bottom: 20px;
  border-left: 4px solid #1485FB;
}

.action-tips p {
  margin: 6px 0;
  font-size: 13px;
  color: #666;
  line-height: 1.5;
}

.action-tips p:first-child {
  margin-top: 0;
}

.action-tips p:last-child {
  margin-bottom: 0;
}

.action-tips strong {
  color: #333;
}

.action-buttons {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

.save-btn {
  min-width: 160px;
  padding: 12px 28px;
  background: linear-gradient(135deg, #1485FB 0%, #0066CC 100%);
  border: none;
  color: white;
  font-weight: 500;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(20, 133, 251, 0.3);
}

.save-btn:hover:not(.is-disabled) {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(20, 133, 251, 0.4);
}

.save-btn:active:not(.is-disabled) {
  transform: translateY(0);
  box-shadow: 0 2px 10px rgba(20, 133, 251, 0.3);
}

.save-btn.is-disabled {
  background: linear-gradient(135deg, #c0c4cc 0%, #a6a9ad 100%);
  border-color: #c0c4cc;
  color: #fff;
  cursor: not-allowed;
  box-shadow: none;
}

/* 骨架屏样式 */
.loading-skeleton {
  width: 100%;
  padding: 16px;
}

/* 响应式设计 */
@media (max-width: 992px) {
  .main-layout {
    flex-direction: column;
  }
  
  .sidebar {
    width: 100%;
    margin-bottom: 16px;
  }
  
  .content {
    padding: 16px;
  }
  
  .transfer-wrapper {
    max-width: 100%;
  }
  
  .transfer-section {
    padding: 16px;
  }
}

@media (max-width: 768px) {
  .header-title h1 {
    font-size: 18px;
  }
  
  .action-buttons {
    flex-direction: column;
  }
  
  .action-buttons .el-button {
    width: 100%;
  }
  
  ::v-deep .custom-transfer .el-transfer__buttons {
    padding: 0 16px;
  }
  
  ::v-deep .custom-transfer .el-transfer-panel__body {
    height: 280px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/reset_query_conditions.vue